type DOMAttributes = React.DOMAttributes<any>;
type EventFilter = {
  [TAttr in keyof DOMAttributes]?: DOMAttributes[TAttr] extends React.EventHandler<any> | undefined
    ? boolean
    : never;
};

type Props = React.ComponentProps<"div"> & {
  filter: EventFilter;
};

export function EventPropagationBoundary({ filter, ...props }: Props) {
  const mappedProps = {
    ...props,
    ...Object.fromEntries(
      Object.entries(filter)
        .filter(([_, filtered]) => filtered)
        .map(([attr, _]) => [
          attr,
          (e: React.SyntheticEvent) => {
            e.stopPropagation();
            if (attr in props) {
              return (props as any)[attr](e);
            }
          },
        ]),
    ),
  };

  mappedProps.onClick;

  return <div {...mappedProps} />;
}
